import introJs from 'intro.js';

export default {
  namespaced: true,

  state: {
    activeDropdown: null,
    isMapFiltersActive: false,
    documentTitle: document.title,
    isFullscreen: false,
    isTourActive: false,

    // We explicitly don't support IE at all.

    // We also *currently* don't support Edge. See note here:
    // https://gitlab.com/policy-link/data_atlas/-/issues/199#note_414673152
    isSupported: !window.navigator.userAgent.match(/(MSIE|Trident|Edge)/),
  },

  actions: {
    launchTour: ({ commit, state, rootState }, tourSteps) => {
      if (!rootState.display.allowTour || state.isTourActive) return;

      introJs()
        .setOptions({
          overlayOpacity: 0.3,
          steps: tourSteps,
        })
        .start()
        .onexit(() => {
          if (state.isTourActive) commit('deactivateTour');
        });

      commit('activateTour');
    },
  },

  /* eslint-disable no-param-reassign */
  mutations: {
    openDropdown: (state, { id }) => {
      state.activeDropdown = id;
    },

    closeDropdown: (state) => {
      state.activeDropdown = null;
    },

    openMapFilters: (state) => {
      state.isMapFiltersActive = true;
    },

    closeMapFilters: (state) => {
      state.isMapFiltersActive = false;
    },

    setDocumentTitle: (state, { title }) => {
      const DIVIDER = ' | ';
      const site = state.documentTitle.split(DIVIDER).pop();

      state.documentTitle = [title, site].filter((x) => x).join(DIVIDER);
    },

    toggleFullscreen: (state) => {
      state.isFullscreen = !state.isFullscreen;
    },

    activateTour: (state) => {
      state.isTourActive = true;
    },

    deactivateTour: (state) => {
      state.isTourActive = false;
    },
  },
};
